export function setSessionKeyValue(key, value) {
  sessionStorage[key] = value
}

export function getSessionKeyValue(key) {
  return sessionStorage[key]
}

export function setLocalKeyValue(key, value) {
  localStorage[key] = value
}

export function getLocalKeyValue(key) {
  return localStorage[key]
}

export function setSessionPhone(phone) {
  sessionStorage.phone = phone
}
export function getSessionPhone() {
  return sessionStorage.phone
}

export function getToken() {
  return localStorage.token;
}

export function removeToken() {
  return localStorage.removeItem("token")
}

export function setToken(token) {
  localStorage.token = token;
}

export function setUserPhone(phone) {
  localStorage.user_phone = phone
}
export function getUserPhone() {
  return localStorage.user_phone
}
export function setUserRole(role) {
  localStorage.user_role = role
}
export function getUserRole(role) {
  return localStorage.user_role
}

export function getUserSettings() {
  if (typeof localStorage.settings !== "undefined" && localStorage.settings !== null) {
    return JSON.parse(localStorage.settings)
  }
}

export function getSettingsOptionValue(option) {
    let settings = getUserSettings()
    if(settings && settings.options) {
      return settings.options[option]
    }
}

export function setUserSettings(settings) {
  localStorage.settings = JSON.stringify(settings)
}

export function getUserProfile() {
  if (typeof localStorage.profile !== "undefined" && localStorage.profile !== null) {
    return JSON.parse(localStorage.profile)
  }
}

export function setUserProfile(profile) {
  localStorage.profile = JSON.stringify(profile)
}

export function getDateRange() {
  let dateRange
  if(sessionStorage.defaultDateRange) {
    dateRange = JSON.parse(sessionStorage.defaultDateRange)
    dateRange.startDate = new Date(dateRange.startDate)
    dateRange.endDate = new Date(dateRange.endDate)
  }
  else {
    let endDate = new Date()
    endDate.setDate(endDate.getDate() - 30)
    dateRange = {startDate: endDate, endDate:new Date(), key:'selection'}
  }
  return dateRange
}

export function setDateRange(dateRange) {
  sessionStorage.defaultDateRange = JSON.stringify(dateRange)
}



// WEBPACK FOOTER //
// ./src/storage.js